import type { ButtonHTMLAttributes } from "react";

// Button — codified from Claude Design. Variant maps to a token-driven class; no
// business logic, no inline copy (children/aria supplied by the consumer).
export type ButtonVariant = "primary" | "secondary" | "danger";

export function Button({
  variant = "secondary",
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ButtonVariant }) {
  const v =
    variant === "primary" ? " ui-btn--primary" : variant === "danger" ? " ui-btn--danger" : "";
  return <button className={`ui-btn${v}${className ? ` ${className}` : ""}`} {...props} />;
}
